import type { FaireProductEntity } from "../../entity_types/product";

export const p_8sz8f69wsw: FaireProductEntity = {
  token: "p_8sz8f69wsw",
  type: "product",
  name: "Orange Calcite Sphere | Crystal Spheres",
  brandToken: "b_en1yij2pf6",
  brandName: "Natures Artifacts Inc",
  imageUrl:
    "https://cdn.faire.com/fastly/b88d95fb1937072bf206ecb462387dc46843762407dde62a5226e854129c7178.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8d8426974b9a4ddd36396281cd5827f207711efde8a5cfeb18c4c37fcce4b5bd.jpeg",
    "https://cdn.faire.com/fastly/fd8c9bcb6b1dee31a43b60ed2d7f2f3a3e7b195dda92064b4ee77ed51b76abc6.jpeg",
    "https://cdn.faire.com/fastly/5d5371ca81b3f860f1a39e996cfb18430320770e5397c4e6ec79c457a36c423d.jpeg",
    "https://cdn.faire.com/fastly/a97912fccfd9228c4ba8ba508eff244d143631c9f390a5dd73b41804441c8b62.jpeg",
    "https://cdn.faire.com/fastly/fc266c02c410d711fdd1aa486da316b2f8db7c51ae0a2895b97a805a5386d72f.jpeg",
    "https://cdn.faire.com/fastly/9d0ed91ff5481d2fb16479dfabed76ec9d7896a0afe530720525fd7ea617141d.jpeg",
    "https://cdn.faire.com/fastly/b682068851946d3ab0ead92854c21873625c447a465e07fe63dcf917edfe9159.jpeg",
    "https://cdn.faire.com/fastly/faa20028ef847551d3ca7330f0ab83feb580ac446a2586ce0e1e8d7c76dd65dc.jpeg",
    "https://cdn.faire.com/fastly/e450be84441446c789ed8b4d3e78cf8edc349542d5e78e5ae4a9045392df0bbc.jpeg",
    "https://cdn.faire.com/fastly/c6880626da8b7d337f362f8fd258384b086094dbf1ceb036a69a71e64c4055a1.jpeg",
  ],
  priceDollars: 17.32,
  description:
    "Orange Calcite is a powerful healing stone containing the element of fire. It links spiritual realm to the physical body and aids in healing emotional issues and removing energy blockages within the body. In the form of a sphere, it radiates an extremely gentle, cleansing and revitalizing energy in all directions, harmoniously.  Easy to hold and work with during meditation and spiritual practices, to bring back optimism, joy and positive energy. Can be placed as part of artistic decor. An amazing gift for crystal lovers. Perfectly fits into any collection of healing crystals. Buy our high quality Orange Calcite Sphere to offer your customers a delightful crystal shopping experience. \n\n\nSize: 5 cm",
  tags: [],
  msrpDollars: 34.64,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:24:58.509Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
